import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';

@Injectable({
  providedIn: 'root'
})
export class PendenciaMotivoDBService extends DatabaseService {
    override classname: string = 'PendenciaMotivoDBService';
    override table = 'pendencia_motivo';

    protected override migration: number = 1;

    override indices = [
        { name: "by_id", field: "id", unique: false, multiEntry: false },
        { name: "by_descricao", field: "descricao", unique: false, multiEntry: false }
    ];
}
